import { useMediaQuery, useTheme } from '@mui/system';

export const useStyles = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isXtraLargeScreen = useMediaQuery(theme.breakpoints.up('xl'));

  return { isSmallScreen, isMediumScreen, isXtraLargeScreen };
};
